import React from 'react';
import { Link } from 'react-router-dom';
import { toggleLang } from '../utils/i18n';

const Footer = () => {
  return (
    <footer>
      <div className="wrap">
        <div className="foot-top">
          <div className="foot-brand">
            <Link className="brand" to="/" style={{ color: 'var(--bone)' }}>
              <span className="brand-mark"></span>
              <span>Cambérène<small>SN · 221</small></span>
            </Link>
            <h2 data-i18n="foot_brand_tagline">Le village,<br />en ligne.</h2>
            <p data-i18n="foot_brand_desc">Plateforme communautaire portée par les habitants de Cambérène — récits, archives, vie locale, économie, sport.</p>
            <div className="foot-soc">
              <a href="#">IG</a>
              <a href="#">FB</a>
              <a href="#">YT</a>
              <a href="#">TT</a>
              <a href="#">X</a>
            </div>
          </div>
          <div>
            <h5 data-i18n="foot_explore_title">Explorer</h5>
            <ul>
              <li><Link to="/" data-i18n="foot_l1">Découvrir</Link></li>
              <li><Link to="/histoire" data-i18n="foot_l2">Histoire</Link></li>
              <li><Link to="/spiritualite" data-i18n="foot_l_spi">Spiritualité</Link></li>
              <li><Link to="/tourisme" data-i18n="foot_l3">Tourisme</Link></li>
              <li><Link to="/talents" data-i18n="foot_l4">Talents</Link></li>
              <li><Link to="/asc" data-i18n="foot_l5">ASC &amp; Foot</Link></li>
              <li><Link to="/actualites" data-i18n="foot_l_news">Actualités</Link></li>
              <li><Link to="/galerie" data-i18n="foot_l6">Galerie</Link></li>
              <li><Link to="/annuaire" data-i18n="foot_l_dir">Annuaire</Link></li>
            </ul>
          </div>
          <div>
            <h5 data-i18n="foot_community_title">Communauté</h5>
            <ul>
              <li><Link to="/bibliotheque" data-i18n="foot_c_lib">Bibliothèque numérique</Link></li>
              <li><Link to="/programme-niane" data-i18n="foot_c_prog">Programme Niani</Link></li>
              <li><a href="#" data-i18n="foot_c1">Devenir contributeur</a></li>
              <li><a href="#" data-i18n="foot_c2">Soumettre une photo</a></li>
              <li><a href="#" data-i18n="foot_c3">Référencer un commerce</a></li>
              <li><a href="#" data-i18n="foot_c4">Diaspora</a></li>
              <li><a href="#" data-i18n="foot_c5">Partenaires</a></li>
              <li><a href="#" data-i18n="foot_c6">Presse &amp; média</a></li>
            </ul>
          </div>
          <div>
            <h5 data-i18n="foot_contact_title">Mairie &amp; Contact</h5>
            <ul>
              <li><Link to="/mairie" data-i18n="foot_ct_mairie">La Mairie de Cambérène</Link></li>
              <li><a href="#" data-i18n="foot_ct1">Cambérène, Dakar 14.78°N</a></li>
              <li><a href="mailto:contact@camberene.sn">contact@camberene.sn</a></li>
              <li><a href="tel:+22133">+221 33 ____</a></li>
              <li><a href="#" data-i18n="foot_ct3">Carte du village</a></li>
              <li><a href="#" data-i18n="foot_ct4">Mentions légales</a></li>
              <li><a href="#" data-i18n="foot_ct5">Charte communautaire</a></li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span data-i18n="foot_copy">© 2026 Cambérène — Tous droits réservés</span>
          <span data-i18n="foot_made">Made with care · à Cambérène, par Cambérène</span>
          <button className="lang-pill lang-toggle" onClick={toggleLang} aria-label="Switch language">EN</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
